import { Component, OnInit } from '@angular/core';
import {CommonComponent} from '../common/common.component';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotificationsService} from "../../../services/notifications.service";
import {ToastaService} from "ngx-toasta";
import {TranslateService} from "@ngx-translate/core";
import {DialogService} from "primeng/dynamicdialog";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {query} from "@angular/animations";
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-web-redirect',
  templateUrl: './web-redirect.component.html',
  styleUrls: ['./web-redirect.component.scss']
})
export class WebRedirectComponent extends CommonComponent implements OnInit {
  externalReferenceCode  = this.activatedRoute.snapshot.queryParamMap.get('externalReferenceCode');
  constructor(
    private activatedRoute: ActivatedRoute,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
    const pathParams: Params = this.activatedRoute.snapshot.params;
    const queryParams: Params = this.activatedRoute.snapshot.params;

    if (pathParams?.code != null) {
      this.router.navigate(['onboarding'], {queryParams: {externalReferenceCode: this.externalReferenceCode, code: pathParams.code}});
    } else {
      this.router.navigate(['onboarding'], {queryParams});
    }

  }

}
